import { z } from 'zod';

export const productDiscountPercentSchema = z.number().int().min(0).max(100).optional();

export type ProductDiscountPercentSchema = z.infer<typeof productDiscountPercentSchema>;
